export default "__VITE_ASSET__B0tBcz79__"